import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';

import ConfigurablePageApp from '../../apps/ConfigurablePageApp';

import '../../../scss/global.scss';

export default function configurablePage(i18n) {
  const appState = window.__CONFIG__ || {};
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const configurablePageRoot = document.getElementById('configurable-page-root');

  // Header is server side rendered in express-react library
  // todo: Add I18nContext wrapper here and in express-react as well
  if (headerRoot) {
    hydrateRoot(headerRoot, <Header headerConfig={headerConfig} />);
  }

  if (configurablePageRoot) {
    hydrateRoot(
      configurablePageRoot,
      <I18nContextProvider i18nInstance={i18n}>
        <ConfigurablePageApp appState={appState} environment={environment} />
      </I18nContextProvider>,
    );
  }
}
